import { useMutation } from '@tanstack/react-query'
import { createPositionRequirement } from 'api/company/position/requirement/createPositionRequirement'

type Response = Awaited<ReturnType<typeof createPositionRequirement>>
type Request = Parameters<typeof createPositionRequirement>[0]

export const useCreatePositionRequirementMutation = () => {
  return useMutation<Response, Error, Request>({
    mutationFn: createPositionRequirement,
  })
}
